import { memo, useEffect, useState } from "react";
import VagaroLogo from "./VagaroLogo";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import RecordingAlert from "../Components/RecordingAlert";
import ExtendTimeModal from "../PopupModal/ExtendTimeModal";
import moment from "moment";
import EndLiveStream from "../GeneralFunctions/EndLiveStream";
import ExtendTime from "../GeneralFunctions/ExtendTime";

function TopProgressBar({ call, isHostNotJoined, hostBeRightBack, vertualFocusedContent, setVertualFocusedContent }) {
  const {
    role,
    recordingNotification,
    setRecordingNotification,
    errorMessage,
    appStartTimeUTC,
    appEndTimeUTC,
    setShowInformationStrip,
    setInformationContent,
    isRecordingStarted,
    currentDateTimeUTC,
    sessionStartTimeUTC,
    serverCallId,
    setServerCallId,
    durationUpdated,
    strExtendedEndTimeUTC,
    setDurationUpdated,
    chatThreadClientRef,
  } = useLiveStreamAppContext();

  const { endCall } = EndLiveStream();
  const { extendTimeFunction } = ExtendTime();
  
  const [totalDuration, setTotalDuration] = useState(0);
  const [elapsedTime, setelapsedTime] = useState(0);
  const [remainingTime, setRemainingTime] = useState(0);
  const [setRecordingAlert] = useState(isRecordingStarted);
  const [maxExtensionReached, setMaxExtensionReached] = useState(false);
  const [redView, setRedView] = useState(false);
  const [showExtendTime, setShowExtendTime] = useState(false);
  const [classStartTimeUTC] = useState(moment(appStartTimeUTC).local().format("YYYY-MM-DDTHH:mm:ss"));
  const [classEndTimeUTC, setClassEndTimeUTC] = useState(moment(appEndTimeUTC).local().format("YYYY-MM-DDTHH:mm:ss"));
  const [sessionStartTime] = useState(sessionStartTimeUTC ? moment(sessionStartTimeUTC).local().format("YYYY-MM-DDTHH:mm:ss") : null);
  const [extendFlag, setExtendFlag] = useState(900);

  useEffect(() => {
    let mycurrent = moment().utc().format("YYYY-MM-DDTHH:mm:ss")
    let now = Math.floor(new Date(mycurrent).getTime() / 1000);
    let classEndTimeUTC_seconds = new Date(classEndTimeUTC).getTime() / 1000;
    if(now >= classEndTimeUTC_seconds && chatThreadClientRef.current){
      endCall();
    }
  },[chatThreadClientRef.current])

  // Calculate total meeting duration
  useEffect(() => {
    let durationInSeconds;
    let verifyStrExtendedEndTime = strExtendedEndTimeUTC ? new Date(strExtendedEndTimeUTC).getTime() / 1000 - new Date(classEndTimeUTC).getTime() / 1000 === 900 : true;
    if (strExtendedEndTimeUTC && verifyStrExtendedEndTime) {
      setClassEndTimeUTC(strExtendedEndTimeUTC);
    }
    if (sessionStartTime) {
      durationInSeconds = new Date(classEndTimeUTC).getTime() / 1000 - new Date(sessionStartTime).getTime() / 1000;
    } else {
      durationInSeconds = new Date(classEndTimeUTC).getTime() / 1000 - new Date(classStartTimeUTC).getTime() / 1000;
    }
    setTotalDuration(Math.floor(durationInSeconds));
  }, [durationUpdated, appStartTimeUTC, classEndTimeUTC, sessionStartTimeUTC, strExtendedEndTimeUTC]);

  // useEffect to dynamically showing progress
  useEffect(() => {
    const intervalId = setInterval(() => {
    let mycurrent = moment().utc().format("YYYY-MM-DDTHH:mm:ss")
    let now = Math.floor(new Date(mycurrent).getTime() / 1000);
    const sessionStartTimeUTC_seconds = sessionStartTimeUTC ? new Date(sessionStartTime).getTime() / 1000 : new Date(classStartTimeUTC).getTime() / 1000;
    let timeDifference = now - sessionStartTimeUTC_seconds;

      if (timeDifference < 0) {
        timeDifference = 0; // Ensure no negative values if before start time
      }

      let totalMeetingDuration = new Date(classEndTimeUTC).getTime() / 1000 - sessionStartTimeUTC_seconds;

      let newRemainingTime = totalMeetingDuration - timeDifference;

      let classEndTimeUTC_seconds = new Date(classEndTimeUTC).getTime() / 1000;
      if (now >= classEndTimeUTC_seconds) {
        newRemainingTime = 0; // Stop the timer after meeting end
      }

      newRemainingTime = Math.max(newRemainingTime, 0); // Prevent negative remaining time

      if (newRemainingTime === 0 && (durationUpdated >= 25 || role === "Attendee")) {
        if (extendFlag < (durationUpdated * 60) || role === "Attendee") {
          newRemainingTime = remainingTime + 1;
          setExtendFlag(extendFlag => extendFlag + 1);
          setRemainingTime(prev => prev + 1)
          if (!redView) setRedView(true);
        }
      }

      if (role === "Presenter") {
        //1.  Handle meeting extension logic ( 1st time extend by 15 minutes )
        if (newRemainingTime === 5 && durationUpdated === 0) {
          let extendedEndTime = moment(classEndTimeUTC).add(15, 'minutes').local().format("YYYY-MM-DDTHH:mm:ss");
          extendTimeFunction(extendedEndTime, 15);
          // console.log("Meeting extended by 15 minutes");
          setDurationUpdated(15);
          setShowInformationStrip(true);
          setInformationContent({
            type: "success",
            message: "15 minutes extended in your scheduled meeting.",
          });
        }

        // Handle notifications for 5 minutes or 1 minute remaining
        if (newRemainingTime === 300 && durationUpdated >= 15) {
          setShowInformationStrip(true);
          setInformationContent({
            type: "alert",
            message: "5 minutes left in your scheduled meeting.",
            remainingTime: newRemainingTime,
            maxExtensionReached,
            setMaxExtensionReached,
            setRedView,
            classEndTimeUTC,
            setDurationUpdated
          });
        }

        if (newRemainingTime === 60 && durationUpdated >= 15 && extendFlag >= (durationUpdated * 60)) {
          setShowExtendTime(true)
        }

        if (newRemainingTime === 0 && durationUpdated >= 15 && extendFlag >= (durationUpdated * 60)) {
          setRemainingTime(0);
          endCall();
          return;
        }
      }

      setRemainingTime(newRemainingTime);
      setelapsedTime(timeDifference); // Update current time
      if (!serverCallId && role === "Presenter" && newRemainingTime % 5 === 0 && call) {
        let x = { ...call };
        x._info.getServerCallId().then((e) => {
          setServerCallId(e)
        }).catch((e) => {
          console.error("error",e);
        });
      }
    }, 1000); // Update every second

    return () => clearInterval(intervalId);
  }, [remainingTime, redView, elapsedTime, durationUpdated, currentDateTimeUTC, appStartTimeUTC, classEndTimeUTC, sessionStartTimeUTC, call, serverCallId]);

  // Format time in hours:minutes:seconds format
  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleCloseRecording = () => {
    setRecordingNotification(false);
    setRecordingAlert(false);
  };

  useEffect(() => {
    const timeFun =()=>{
      setVertualFocusedContent(true)
    }
    setTimeout(timeFun, 8000);
    return () => {
      clearTimeout(timeFun);
    }
  }, [])

  return (
    <>
      {!errorMessage && recordingNotification === "STOP" && role === "Attendee" && (
        <RecordingAlert handleCloseRecording={handleCloseRecording} message="Recording has stopped" />
      )}

      {!errorMessage && recordingNotification === "START" && role === "Attendee" && !isHostNotJoined && !hostBeRightBack && (
        <RecordingAlert handleCloseRecording={handleCloseRecording} message="This meeting is being recorded. By joining you are giving consent for this meeting to be recorded." />
      )}
      {<div className="top-header-fixed">
        <div className="top-logo">
          <div className="vagaro-logo-link">
            <VagaroLogo />
          </div>
        </div>
        <div className={`top-progress-bar ${!vertualFocusedContent ? 'top-header-show' : ""}`}>
          <section className="meet-progress-bar">
            <div className="meet-time-indicator">
              <span className="meet-time">{formatTime(elapsedTime)}</span>
            </div>
            <div className="meet-progress-indicator">
              <div className="meet-progress-line">
                <div
                  style={{
                    width: `${Math.ceil((elapsedTime / (totalDuration)) * 100)}%`,
                  }}
                ></div>
              </div>
            </div>
            <div className="meet-time-indicator" style={{ color: redView && "#d83f34" }}>
              <span className="meet-time">{formatTime(remainingTime)}</span>
              <span className="meet-status">{redView ? 'over' : 'Remaining'}</span>
            </div>
          </section>
        </div>
      </div>
      }
      {showExtendTime && (
        <ExtendTimeModal
          show={showExtendTime}
          onHide={() => setShowExtendTime(false)}
          remainingTime={remainingTime}
          classEndTimeUTC={classEndTimeUTC}
          setDurationUpdated={setDurationUpdated}
          setMaxExtensionReached={setMaxExtensionReached}
        />
      )}
    </>
  );
}

export default memo(TopProgressBar);